var isRegExp = require('../internals/is-regexp');

module.exports = function (it) {
  if (isRegExp(it)) {
    throw TypeError("The method doesn't accept regular expressions");
  } return it;
};



// WEBPACK FOOTER //
// webpack://pdfmake/node_modules/core-js/internals/not-a-regexp.js